import { useSelector } from "react-redux";
import { api as Api } from "api/http";

export const useHolidays = () => {

    const locale = useSelector((state) => state.locale.currentLang);

    const getHolidays = async (country, year = new Date().getFullYear(), language = locale) => {
        const url = `https://calendarific.com/api/v2/holidays?&api_key=${process.env.REACT_APP_CALENDARIFIC_API_KEY}&country=${country}&year=${year}&language=${language}`;
        const holidays = await Api.get(`/proxy?url=${encodeURIComponent(url)}`, {}).then((_data) => { 
            _data = _data?.response?.holidays?.filter((v,i,a)=>a.findIndex(v2=>(v2.name===v.name))===i);
            let final = { months: [] };
            for (var i = 0; i < _data?.length; i++) {
                const month_number = _data[i]?.date?.datetime?.month;
                const day_number = _data[i]?.date?.datetime?.day;
                const month = final?.months?.filter(e => e?.number == month_number)?.[0];
                if (!month) {
                    final?.months?.push({
                        number: month_number,
                        days: []
                    });
                }
                const day = month?.days?.filter(e => e?.number == day_number)?.[0];
                if (!day) {
                    final?.months?.filter(e => e?.number == month_number)?.[0]?.days.push({
                        number: day_number,
                        events: []
                    });
                }
                final?.months?.filter(e => e?.number == month_number)?.[0]?.days?.filter(e => e?.number == day_number)?.[0]?.events?.push(_data[i]);
            }
            return final;
        });
        return holidays;
    }

    return { getHolidays }
}

